import { RatingType } from '@ui-system/interfaces-rating';
import { pleaseImplement } from '@ui-system/utils';

const Rating = pleaseImplement<RatingType>('Rating');

export default Rating;
